//GET_ALL_TICKETS
export const GET_ALL_TICKETS_REQUEST = "GET_ALL_TICKETS_REQUEST";
export const GET_ALL_TICKETS_SUCCESS = "GET_ALL_TICKETS_SUCCESS";
export const GET_ALL_TICKETS_FAIL = "GET_ALL_TICKETS_FAIL";

//CREATE_TICKET
export const CREATE_TICKET_REQUEST = "CREATE_TICKET_REQUEST";
export const CREATE_TICKET_SUCCESS = "CREATE_TICKET_SUCCESS";
export const CREATE_TICKET_FAIL = "CREATE_TICKET_FAIL";

//UPDATE_TICKET
export const UPDATE_TICKET_REQUEST = "UPDATE_TICKET_REQUEST";
export const UPDATE_TICKET_SUCCESS = "UPDATE_TICKET_SUCCESS";
export const UPDATE_TICKET_FAIL = "UPDATE_TICKET_FAIL";

//ARCHIVE_TICKET
export const ARCHIVE_TICKET_REQUEST = "ARCHIVE_TICKET_REQUEST";
export const ARCHIVE_TICKET_SUCCESS = "ARCHIVE_TICKET_SUCCESS";
export const ARCHIVE_TICKET_FAIL = "ARCHIVE_TICKET_FAIL";

//ADD_COMMENT
export const ADD_COMMENT_REQUEST = "ADD_COMMENT_REQUEST";
export const ADD_COMMENT_SUCCESS = "ADD_COMMENT_SUCCESS";
export const ADD_COMMENT_FAIL = "ADD_COMMENT_FAIL";

//GET_COMMENTS_FOR_ONE_TICKET
export const GET_COMMENTS_FOR_ONE_TICKET_REQUEST =
  "GET_COMMENTS_FOR_ONE_TICKET_REQUEST";
export const GET_COMMENTS_FOR_ONE_TICKET_SUCCESS =
  "GET_COMMENTS_FOR_ONE_TICKET_SUCCESS";
export const GET_COMMENTS_FOR_ONE_TICKET_FAIL =
  "GET_COMMENTS_FOR_ONE_TICKET_FAIL";

//DELETE_COMMENT
export const DELETE_COMMENT_REQUEST = "DELETE_COMMENT_REQUEST";
export const DELETE_COMMENT_SUCCESS = "DELETE_COMMENT_SUCCESS";
export const DELETE_COMMENT_FAIL = "DELETE_COMMENT_FAIL";
